import { Station } from "../types";
import { dlrStations } from "./dlr";
import { tubeStations } from "./tube";

export const allStations: Station[] = dlrStations.concat(tubeStations);
